<template>
    <button class="delete" type='button'
            @click="confirmDelete()">
        <i class="icofont-ui-delete"></i>
    </button>
</template>

<script>

    export default {
        data() {
            return {

            }
        },
        props: {
            url: {
                type: String,
                default: null
            },
            id: {
                type: [Number, String],
                required: true
            },
            confirm_message: {
                type: String,
                default: null
            }
        },
        methods: {
            confirmDelete() {
                const self = this;


                this.$snotify.confirm(self.confirm_message ? self.confirm_message : trans("Are you sure you want to delete this item?"), trans('Confirm deleting'), {
                    timeout: 5000,
                    showProgressBar: true,
                    closeOnClick: false,
                    pauseOnHover: true,
                    position: 'centerCenter',
                    buttons: [
                        {
                            text: self.confirm_message ? trans('Ok') : trans('Yes'),
                            action: (toast) => {
                                this.deleteEntity();
                                this.$snotify.remove(toast.id);
                            },
                            bold: true
                        },
                        {
                            text: trans('No'),
                            action: (toast) => this.$snotify.remove(toast.id)
                        }
                    ]
                });
            },
            deleteEntity() {
                const self = this;

                self.$snotify.async(trans('Deleting...'), '', () => new Promise((resolve, reject) => {
                    axios.delete(self.url)
                        .then(response => {
                            resolve({
                                title: trans('Success!'),
                                body: trans('Deleted'),
                                config: {
                                    timeout: 500,
                                    closeOnClick: true
                                }
                            });

                            // setTimeout(() => window.location = response.data.redirect, 2000);
                            self.$emit('delete', self.id);
                        })
                        .catch(error => {
                            let timeout = 500;
                            let message = trans('Something went wrong, please re-check and try again');

                            if (error.response.data.message) {
                                message = error.response.data.message;
                                timeout = 2000;
                            }

                            reject({
                                title: trans('Error!'),
                                body: message,
                                config: {
                                    timeout: timeout,
                                    closeOnClick: true
                                }
                            })
                        });
                }));
            }
        },
        mounted() {

        }
    }
</script>